


import Axios from "axios";
import Url from "app/shared/constants/Url";
const FetchDatanm = async(nmId,module) => {
    let URL = Url.costMaster.costDataNm;
    let userId = localStorage.getItem("userId");
    let token = localStorage.getItem("springToken");
    const requestParams = {
      auth_key: token,
      user_id: userId,
      reportId:nmId,
      module: module,
    };
     
    
    try {
        const response = await Axios.get(`${URL}`,{
          params:requestParams,
          headers: {
            'accept': 'application/json',
            'Content-Type': 'multipart/form-data'  
          }
        });
        console.log(response,"response")
        if (response.status === 200) {
            return response.data;
           
          }        
      } catch (error) {
        console.error("Error fetching ", error.response?.data || error.message);
        throw error;
      } 
      
};

export default FetchDatanm;